<script>

export default {
  mounted() {
    this.$nextTick(() => {
      if (global.app.$user) {
        global.app.$user.logout()
      }
    })
  }
}

</script>



// WEBPACK FOOTER //
// src/core/legacy-auth/logout.vue